// src/contexts/pedidos/HorarioContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchData, postData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';

const HorarioContext = createContext();

const normalizarHorarios = (resultado) => {
    if (Array.isArray(resultado)) return resultado;
    if (Array.isArray(resultado?.horarios)) return resultado.horarios;
    return [];
};

export const useHorario = () => useContext(HorarioContext);

export const HorarioProvider = ({ children }) => {

    const [horarios, setHorarios] = useState([]);
    const { showAlert } = useAlert();

    const fetchHorarios = async () => {
        try {
            const result = await fetchData('/HorarioFuncionamento/todosHorarios');
            setHorarios(normalizarHorarios(result));
        } catch (error) {
            console.error("Erro ao buscar horários:", error);
        }
    };

    useEffect(() => {
        fetchHorarios();
    }, []);

    const salvarHorarios = async (data) => {
        try {
            // pode ajustar depois para PUT se quiser
            const result = await postData('/HorarioFuncionamento', data);
            setHorarios(normalizarHorarios(result));
            showAlert('Horários salvos com sucesso!');
        } catch (error) {
            showAlert('Erro ao salvar horários!', 'danger');
        }
    };

    return (
        <HorarioContext.Provider
            value={{
                horarios,
                fetchHorarios,
                salvarHorarios
            }}
        >
            {children}
        </HorarioContext.Provider>
    );
};
